module.exports = "/_next/static/images/9f3d4706484865dbd45031facef39943-row-1-with.svg.webp";